import { render, staticRenderFns } from "./BaseDashboard.vue?vue&type=template&id=565fdcd6"
import script from "./BaseDashboard.vue?vue&type=script&lang=js"
export * from "./BaseDashboard.vue?vue&type=script&lang=js"
import style0 from "./BaseDashboard.vue?vue&type=style&index=0&id=565fdcd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports